import { RouteItem } from '@eastcoal/router/types/route'

import { HBCOAL_SALE_PLAN_PAGE_UUID } from './constants/uuid'

export const hbcoalSalePlanRoute: RouteItem = {
  title: '淮北运销网络销售计划',
  uuid: HBCOAL_SALE_PLAN_PAGE_UUID,
  path: '/hbcoalSalePlan',
  Component: () => import('./index')
}
